<template>
  <div>
    <div class="adbtn"  @click="modal10 = true">
      <dl>
        <dt>+</dt>
        <dd>
          我
          <br />要
          <br />添
          <br />加
        </dd>
      </dl>
    </div>

    <Modal
      v-model="modal10"
      title="我来添加"
      class-name="vertical-center-modal"
      @on-ok="okupload"
      @on-cancel="cancel"
    >
      <div class="webaddbox">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="网站名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="网站描述">
            <el-input type="textarea" v-model="form.describe"></el-input>            
          </el-form-item>
          <el-form-item label="网站网址">

             <Input v-model="value12">
                <Select v-model="select1" slot="prepend" style="width:100px">
                    <Option value="http">http://</Option>
                    <Option value="https">https://</Option>
                </Select>                
            </Input> 

          </el-form-item>

          <el-form-item label="所属分类">
            <el-col :span="8">
              <el-form-item>
                <el-select v-model="form.zimu" placeholder="选择字母系列">
                  <el-option label="区域一" value="shanghai"></el-option>
                  <el-option label="区域二" value="beijing"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2" style=" text-align: center;">-</el-col>
            <el-col :span="14">
              <el-select v-model="form.region" placeholder="选择分类">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="网站icon">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileListicon"
              list-type="picture"
            >
              <dl class="upimgdl">
                <dt>
                  <el-button size="small">点击上传</el-button>
                </dt>
                <dd>须上传jpg/png文件,图片需尺寸：宽30px*高30px</dd>
              </dl>
            </el-upload>
          </el-form-item>

          <el-form-item label="网站标志">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileListlogo"
              list-type="picture"
            >
              <dl class="upimgdl">
                <dt>
                  <el-button size="small">点击上传</el-button>
                </dt>
                <dd>须上传jpg/png文件,图片需尺寸：宽138px*高40px</dd>
              </dl>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal10: false,
      select1: 'http',
      value12:'',
      form: {
        name: "",
        zimu: "",
        region: "",
        describe: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      fileListicon: [],
      fileListlogo: []
    };
  },
  methods: {
    okupload() {
      this.$Message.info("提交成功");
    },
    cancel() {
      //this.$Message.info('取消');
    },
    onSubmit() {
      console.log("submit!");
    },
    //上传图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    }
  }
};
</script>

<style lang="scss" scoped>
.adbtn { cursor: pointer;
  dl {
    background: #ffa200;
    width: 40px;
    height: 136px;
    text-align: center;
    color: #fff;
    border-radius: 30px;
    dt {
      padding-top: 10px;
      font-size: 20px;
    }
    dd {
      font-size: 13px;
    }
  }
}

.upimgdl{
  dt{ float: left;}
  dd{ float: left; font-size: 12px; padding-left: 15px; color: #888;}
}

.webaddbox{
  padding-left: 10px; padding-right: 10px;
}

>>> .ivu-btn-primary{background: #ffa200;border-color:#ffa200;}

>>> .el-button:hover{ background: #fff1d8;color: #333;border-color:#ffd181;}

</style>


// WEBPACK FOOTER //
// src/components/publish/addweb.vue